import styles from '@/styles/Ui.module.scss';
import Item from "./NotificationItem.tsx";
import {FC} from 'react';
import {useAtom} from "jotai";
import {notificationsList, popping_notifications} from "@/atoms/common";
import DashboardClass from "@/utils/dashboard_class.ts";
import SystemNotificationComponent from "@/components/SystemNotificationComponent.tsx";
import useNotifications from "@/hooks/notifications.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";


const SimpleSnackbarList:FC = () => {
    const [notifications,] = useAtom(notificationsList)
    const [popping_notif, set_popping_notif] = useAtom(popping_notifications)
    // const navigate = useNavigate()
    const notif = useNotifications()
    
    return (
        <div className={styles.notif_lists}>
            
            {notifications.map((item:any, i:number) => {
                return(
                    <Item
                        active={item.active}
                        key={'notification'+ i}
                        message={item.message}
                        type={item.type}
                        btn_text={item.btn_text}
                        funct={item.funct}
                        index={i}
                    />
                )
            })}
            
            {popping_notif.map((obj:any, i:number) => {
                
                const on_click = () => {
                    if (obj.type === "loan_status_changed" && !obj.is_read) {
                        eventEmitter.emit(CommonClass.CustomEvents.redirect_to, DashboardClass.dashboard_routes.PendingLoans)
                        // navigate(DashboardClass.dashboard_routes.PendingLoans)
                        
                    } else if (obj.type === "contract_signed_successful" && !obj.is_read) {
                        eventEmitter.emit(CommonClass.CustomEvents.redirect_to, DashboardClass.dashboard_routes.StandartCredit)
                        
                        // navigate(DashboardClass.dashboard_routes.StandartCredit)
                        
                    } else {
                        set_popping_notif([])
                        notif.notification_sidebar_handle()
                    }
                }
                
                
                return (
                    <SystemNotificationComponent
                        obj={obj}
                        on_click={on_click}
                        key={`notif_${i}`}
                    />
                )
            })}
            
        </div>
    )
}
export default SimpleSnackbarList